import React, { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import Header from "./Header";
import Footer from "./Footer";

function ClientForm() {
    
    const [nombreEmpresa, setNombreEmpresa] = useState('Mi Consultorio');
    const [numColaboradores, setNumColaboradores] = useState('5');
    const [direccion, setDireccion] = useState('');
    const [tipoEmpresa, setTipoEmpresa] = useState('2');
    const [pais, setPais] = useState('Colombia');
    const [telefono, setTelefono] = useState('');
    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();
    const [client, setClient] = useState([]);
    const [headerCollapsed, setHeadercollapsed] = useState('collapse-hdr');
    let userdata = [];
    let history = useHistory();


    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            nombre: nombreEmpresa,
            empleados: numColaboradores,
            direccion: direccion,
            pais: pais,
            telefono: telefono,
            admin: userdata.user_id,
            tipo_cliente: tipoEmpresa
        };

        
        axios.post('/client', conf)
          .then(
              response => {
                  setErrorlist({});
                  setLoading(false);

                  userdata.up = response.data.up;
                  userdata.client_id = response.data.client_id;
                  
                  localStorage.setItem('userdata',JSON.stringify(userdata));

                  //history.push('/home');
                  history.push('/');
              }
          )
          .catch(
              err => {
                  console.log(err.response.data);
                  setErrorlist(err.response.data.errors);
                  setLoading(false);
              }
          )
    }

    return (
      <div className="hold-transition">
        <Header headerCollapsed={headerCollapsed} />
        <div className="row">
          <div className="col-md-1">
          </div>
          <div className="col-md-10">
            <div className="row mb-2" style={{marginTop:'30px'}}>
                <div className="col-sm-8">
                    <h1 className="m-0">Configuración de la cuenta</h1>
                </div>
            </div>
            <div className="card card-primary">
              <form id="quickForm" onSubmit={handleSubmit}>
                <div className="card-body">

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="companyName">Nombre de tu empresa</label>
                        <input type="text" name="company-name" className="form-control" id="companyName" defaultValue={nombreEmpresa} autoFocus onChange={(e) => setNombreEmpresa(e.target.value)} />
                        <div className="invalid-feedback visible">
                            {errorlist.nombre}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="employees">Número de colaboradores</label>
                        <select name="employees" id="employees" className="form-control" onChange={(e) => setNumColaboradores(e.target.value)}>
                          <option value="5">1 - 5</option>
                          <option value="10">6 - 10</option>
                          <option value="20">11 - 20</option>
                          <option value="100">20 +</option>
                        </select>
                        <div className="invalid-feedback visible">
                            {errorlist.empleados}
                        </div>
                      </div> 
                      <div className="form-group">
                        <label htmlFor="companyAddress">Dirección</label>
                        <input type="text" name="company-address" className="form-control" id="companyAddress" onChange={(e) => setDireccion(e.target.value)} />
                        <div className="invalid-feedback visible">
                            {errorlist.direccion}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="companyType">Tipo de empresa</label>
                        <select name="company-type" className="form-control" id="companyType" onChange={(e) => setTipoEmpresa(e.target.value)}>
                          <option value="1">Consultorio médico</option>
                          <option value="2">Consultorio odontológico</option>
                          <option value="3">Clínica estética</option>
                          <option value="4">Otro</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="country">País</label>
                        <select name="country" className="form-control" id="country" onChange={(e) => setPais(e.target.value)}>
                          <option value="Colombia">Colombia</option>
                          <option value="Ecuador">Ecuador</option>
                          <option value="Peru">Perú</option>
                          <option value="Panama">Panamá</option>
                          <option value="Otro">Otro</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="phoneNumber">Número telefónico</label>
                        <input type="text" name="phone-number" className="form-control" id="phoneNumber" placeholder="Número telefónico" onChange={(e) => setTelefono(e.target.value)} />
                        <div className="invalid-feedback visible">
                            {errorlist.telefono}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="card-footer" style={{textAlign:'center'}}>
                  <button type="submit" className="btn btn-primary btn-lg">
                    Continuar&nbsp;
                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                  </button>
                </div>
              </form>
            </div>  
          </div>
        </div>
        <Footer />
      </div>
    );
}
export default ClientForm;